import React from 'lib/react';
import {
  EVGrid,
  EVButton,
} from 'lib/components';
import { useSelector, useDispatch } from 'lib/redux';
import { ORDER_HISTORY_FILTERS_UPDATE_ORG_NODES_LIST, ORDER_HISTORY_APPLY_FILTERS } from 'constants/ActionTypes';
import { useTranslation } from 'lib/translation';
import { isEntitledForGlobalSearchSelector } from 'utils/appSelectors.utils';
import { getAllOrgIds } from 'features/orderHistory/OrderHistory.utils';
import OrgNodesFilter from './components/orgNodesFilter';
import DateFilter from './components/dateFilter';
import ProductsFilter from './components/productsFilter';
import StatusFilter from './components/statusFilter';
import FilterStyles from './FilterStyles';
import { DATE_RANGES } from './commonComponents/dateRangeFilter/DateFilter.utils';

function Filters() {
  const {
    orgNodeList, productIds, statusList, dateError, selectedDateOption,
  } = useSelector(({ orderHistory }) => orderHistory.orderHistoryFilters);

  const isEntitledForGlobalSearch = useSelector(isEntitledForGlobalSearchSelector);
  const { orgDescendants, initParameters } = useSelector((state) => state.userData);
  const profileHasPermissionAtOrgNode = isEntitledForGlobalSearch || initParameters?.profileHasPermissionAtOrgNode;
  const dispatch = useDispatch();

  const classes = FilterStyles();
  const { t } = useTranslation();

  const setSelectedNodeIds = (updatedOrgNodeList) => dispatch({ type: ORDER_HISTORY_FILTERS_UPDATE_ORG_NODES_LIST, updatedOrgNodeList });

  const handleApplyFilters = () => dispatch({ type: ORDER_HISTORY_APPLY_FILTERS });

  const handleResetFilters = () => dispatch({ type: ORDER_HISTORY_APPLY_FILTERS, reset: true });

  const allOrgIds = getAllOrgIds(orgDescendants);
  const showResetButton = (isEntitledForGlobalSearch ? orgNodeList?.length !== allOrgIds?.length : orgNodeList?.length > 0)
   || productIds?.length > 0 || statusList?.length > 0 || selectedDateOption !== DATE_RANGES.LAST_YEAR;

  return (
    <EVGrid className={classes.pageContainer}>
      <EVGrid className={classes.filtersGroup}>
        <ProductsFilter />
        <StatusFilter />
        {profileHasPermissionAtOrgNode && (
          <OrgNodesFilter
            rootOrgNode={orgDescendants}
            selectedNodeIds={orgNodeList}
            setSelectedNodeIds={setSelectedNodeIds}
          />
        )}
        <DateFilter />
      </EVGrid>
      <EVButton
        id="apply-filters"
        disabled={dateError}
        variant="outlined"
        color="primary"
        onClick={handleApplyFilters}
        style={{ height: '44px' }}
      >
        {t('finalize_order__order_summary__apply_promo_code')}
      </EVButton>
      <EVButton
        disabled={!showResetButton}
        id="reset-filters"
        color="primary"
        onClick={handleResetFilters}
        style={{ height: '44px' }}
      >
        {t('common__reset')}
      </EVButton>
    </EVGrid>
  );
}

export default Filters;
